var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover-dot",style:({transform: ("translate3d(" + (_vm.x.value) + "px, " + (_vm.y.value) + "px, 0)")})},[_c('transition',[(_vm.hoverTarget)?_c('div',{key:"dot",staticClass:"dot"}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }